import ActiveSafetyTeamTable from './ActiveSafetyTeamTable'
export { ActiveSafetyTeamTable }
export default ActiveSafetyTeamTable
